import React from 'react'
import { Link } from 'react-router-dom'
import VipLayout from '../../../components/vip/VipLayout'

const AiSolutionsIndexPage: React.FC = () => {
  return (
    <VipLayout>
      <section className="hero">
        <div className="container">
          <span className="kicker">AI Solutions</span>
          <h1>AI 解决方案</h1>
          <p>我们不仅提供 AI 相关备案与登记咨询，也希望帮助企业理解大模型落地的技术路径、业务场景与合规边界，形成从部署到上线更清晰的解决方案视角。</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid cols-2">
            <div className="card service-card">
              <h3>企业 AI 合规解决方案</h3>
              <p className="lead" style={{fontSize: '15px'}}>围绕算法备案、大模型登记 / 备案、AI 上线公示、数据与安全机制，帮助企业建立更完整的合规视角。</p>
              <Link className="btn btn-secondary" to="/vip/services/ai-compliance">查看相关服务</Link>
            </div>
            <div className="card service-card">
              <h3>开源大模型私有化部署解决方案</h3>
              <p className="lead" style={{fontSize: '15px'}}>围绕模型选择、部署架构、算力资源、系统接入与企业内部场景适配，提供部署咨询建议。</p>
              <Link className="btn btn-secondary" to="/vip/ai-solutions/private-deployment">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>企业知识库训练 / 微调解决方案</h3>
              <p className="lead" style={{fontSize: '15px'}}>围绕企业资料清洗、知识整理、RAG / 微调路线、数据治理与训练策略建立更可执行的实施框架。</p>
              <Link className="btn btn-secondary" to="/vip/ai-solutions/training-and-finetuning">查看详情</Link>
            </div>
            <div className="card service-card">
              <h3>AI 智能体应用咨询</h3>
              <p className="lead" style={{fontSize: '15px'}}>面向企业客服、营销、运营、知识问答等应用，帮助企业理解智能体接入路径与上线边界。</p>
              <Link className="btn btn-secondary" to="/vip/contact">咨询方案</Link>
            </div>
          </div>
        </div>
      </section>
    </VipLayout>
  )
}

export default AiSolutionsIndexPage
